<!--
* @description 直接放图片页面
* @fileName content.vue
* @author xuesong
* @date 2022/09/20 18:08:51
!-->
<template>
  <div id="contentBg">
    <img src="@/assets/contentBg/contentPic1.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'ContentVue'
}

</script>
<style lang='scss' scoped>
#contentBg {
  width: 100%;
  height: 100%;
  background-color: rgb(9,12,22);
  img {
    width: 100%;
    height: 99.5%;
  }
}
</style>
